import { useEffect } from "react";

// React 19 natively hoists <meta>/<link> rendered in components into <head>.
// <title> is set via document.title to update the existing head title in place
// (avoids duplicate <title> tags alongside the static index.html one).
export const Seo = ({ title, description, canonical, jsonLd }) => {
  useEffect(() => {
    if (!title) return;
    const prev = document.title;
    document.title = title;
    return () => {
      document.title = prev;
    };
  }, [title]);

  useEffect(() => {
    if (!description) return;
    const tag = document.querySelector('meta[name="description"]');
    if (!tag) return;
    const prev = tag.getAttribute("content");
    tag.setAttribute("content", description);
    return () => {
      tag.setAttribute("content", prev);
    };
  }, [description]);

  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <>
      {canonical && <link rel="canonical" href={canonical} />}
      {blocks.map((block, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(block)}
        </script>
      ))}
    </>
  );
};

export const breadcrumbJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    item: item.url,
  })),
});
